import React from 'react';

const MoneyChangeIcon = () => (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M37.1668 14.9993V24.9993C37.1668 30.8327 33.8335 33.3327 28.8335 33.3327H16.7335C17.0168 32.5493 17.1668 31.716 17.1668 30.8327C17.1668 26.6993 13.8168 23.3327 9.66683 23.3327C7.31683 23.3327 5.20016 24.4327 3.8335 26.1327V14.9993C3.8335 9.16602 7.16683 6.66602 12.1668 6.66602H28.8335C33.8335 6.66602 37.1668 9.16602 37.1668 14.9993Z"
      fill="url(#paint0_linear_12047_16884)"
    />
    <path
      d="M20.5002 24.1673C22.8013 24.1673 24.6668 22.3018 24.6668 20.0007C24.6668 17.6995 22.8013 15.834 20.5002 15.834C18.199 15.834 16.3335 17.6995 16.3335 20.0007C16.3335 22.3018 18.199 24.1673 20.5002 24.1673Z"
      fill="url(#paint1_linear_12047_16884)"
    />
    <path
      d="M31.3335 24.5827C30.6502 24.5827 30.0835 24.016 30.0835 23.3327V16.666C30.0835 15.9827 30.6502 15.416 31.3335 15.416C32.0168 15.416 32.5835 15.9827 32.5835 16.666V23.3327C32.5835 24.016 32.0168 24.5827 31.3335 24.5827Z"
      fill="url(#paint2_linear_12047_16884)"
    />
    <path
      d="M9.6665 23.334C7.3165 23.334 5.19984 24.434 3.83317 26.134C2.78317 27.4173 2.1665 29.0507 2.1665 30.834C2.1665 34.984 5.53317 38.334 9.6665 38.334C12.9332 38.334 15.7165 36.2506 16.7332 33.334C17.0165 32.5507 17.1665 31.7173 17.1665 30.834C17.1665 26.7007 13.8165 23.334 9.6665 23.334ZM14.0998 34.1007C14.0498 34.2007 13.9831 34.3173 13.8998 34.4007L12.5498 35.734C12.3831 35.9173 12.1498 36.0006 11.9165 36.0006C11.6665 36.0006 11.4332 35.9173 11.2665 35.734C10.9665 35.4507 10.9332 35.0006 11.1165 34.6673H7.34981C6.14981 34.6673 5.16648 33.684 5.16648 32.4673V32.284C5.16648 31.7673 5.58313 31.3673 6.08313 31.3673C6.58313 31.3673 6.99988 31.7673 6.99988 32.284V32.4673C6.99988 32.6673 7.14981 32.834 7.34981 32.834H11.1165C10.9332 32.484 10.9665 32.0506 11.2665 31.7506C11.6165 31.4006 12.1998 31.4006 12.5498 31.7506L13.8998 33.1006C13.9831 33.184 14.0498 33.2839 14.0998 33.4006C14.1831 33.6173 14.1831 33.8674 14.0998 34.1007ZM14.1665 29.384C14.1665 29.9007 13.7499 30.3006 13.2499 30.3006C12.7499 30.3006 12.3331 29.9007 12.3331 29.384V29.2007C12.3331 29.0007 12.1832 28.834 11.9832 28.834H8.21651C8.39984 29.184 8.36647 29.6173 8.06647 29.9173C7.8998 30.084 7.66654 30.184 7.41654 30.184C7.18321 30.184 6.94987 30.084 6.7832 29.9173L5.43321 28.5673C5.34987 28.484 5.28322 28.384 5.23322 28.2674C5.14988 28.0507 5.14988 27.8006 5.23322 27.5673C5.28322 27.4673 5.34987 27.3506 5.43321 27.2673L6.7832 25.934C7.1332 25.5673 7.71647 25.5673 8.06647 25.934C8.36647 26.2173 8.39984 26.6673 8.21651 27.0007H11.9832C13.1832 27.0007 14.1665 27.984 14.1665 29.2007V29.384Z"
      fill="url(#paint3_linear_12047_16884)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12047_16884"
        x1="33.838"
        y1="19.9992"
        x2="7.65609"
        y2="18.6257"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BAAA1" />
        <stop offset="1" stop-color="#0B8DAA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_12047_16884"
        x1="23.8346"
        y1="20.0006"
        x2="17.2827"
        y2="19.7256"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0BAAA1" />
        <stop offset="1" stop-color="#0B8DAA" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_12047_16884"
        x1="32.3338"
        y1="19.9993"
        x2="30.365"
        y2="19.9768"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0BAAA1" />
        <stop offset="1" stop-color="#0B8DAA" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_12047_16884"
        x1="15.6685"
        y1="30.8339"
        x2="3.87502"
        y2="30.3389"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0BAAA1" />
        <stop offset="1" stopColor="#0B8DAA" />
      </linearGradient>
    </defs>
  </svg>
);

export default MoneyChangeIcon;
